
import { Vue, Component } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { InformationListDTO, updateInformationVisits } from '@/api/information'
import store from '@/store'

@Component
export default class InformationDetail extends Vue {
  @Getter companyName: string // 公司名称
  @Getter logoUrl: string // 公司头像

  information: InformationListDTO = {
    articleContent:'',
  }

  handleBack() {
    this.$router.back()
  }

  created() {
    this.information = Object.assign(this.information,this.$route.query)
  }

  mounted() {
    updateInformationVisits({
      informationId: this.information.informationId
    }).then((res) => {
      this.information.articleContent = (res.data && res.data.articleContent) || ''
      this.information.visitsNumber = res.data.visitsNumber
    })
  }
}
